import { useState } from "react";
import { FcCallback } from "react-icons/fc";
import axios from "axios";
import "./RequestCallbackButton.css"; // Import CSS file
import { useUser } from "../../context/UserProvider";


const RequestCallbackButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
        _id: ""
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");
    const {mongoUser} = useUser();


    const toggleForm = () => {
        setIsOpen(!isOpen);
        setSuccess(false);
        setError("");
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        try {
            const response = await axios.post(`${import.meta.env.VITE_REQUEST_CALLBACK}/request-callback`, formData);
            if (response.status === 201) {
                setSuccess(true);
                const mongoUserId = mongoUser?._id || ""
                setFormData({ name: "", email: "", phone: "", message: "", id: mongoUserId  });
            } else {
                setError("Something went wrong. Please try again.");
            }
        } catch (err) {
            setError("Failed to submit request.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="callback-container">
            {!isOpen && (
                <button onClick={toggleForm} className="callback-button">
                    <FcCallback className="callback-icon" />
                    <span className="callback-text">Request Callback</span>
                </button>
            )}

            {isOpen && (
                <div className="callback-form">
                    <h3>Request a Callback</h3>
                    <form onSubmit={handleSubmit} className="callbackForm">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Phone (10 digits: numbers only)"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            pattern="\d{10}"
                        />
                        <textarea
                            name="message"
                            placeholder="Your Message or Question"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        ></textarea>

                        {error && <p className="error-text">{error}</p>}
                        {success && <p className="success-text">Request submitted successfully!</p>}

                        <div className="formButtonsArea">
                            <button type="button" onClick={toggleForm} className="close-btn">
                                Close
                            </button>
                            <button type="submit" disabled={loading} className="submit-btn">
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default RequestCallbackButton;
